import React, { useState } from 'react';

import {
  SidePage,
  Stack,
  Button,
  Divider,
  VirtualizedList,
} from '@gogame/components';

import SearchField, {
  useSearchedData,
} from 'scenes/Users/AdminUsers/components/SearchField';

import Actions from './Actions';
import { useLoadDepartments, useIsUpdating, useCreateDepartment } from './data';

const Departments = ({ onClose, onExited, open }) => {
  const { data, isLoading, isRefetching } = useLoadDepartments();
  const isUpdating = useIsUpdating();

  const [searchQuery, setSearchQuery] = useState('');

  const searchedData = useSearchedData({ data, searchQuery });

  const [createDepartment] = useCreateDepartment();

  return (
    <SidePage
      open={open}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isUpdating}
      fetching={isRefetching}
      size={'md'}
    >
      <SidePage.Title title={'Departments'} />
      <SidePage.NewBody disableGutters={true} dense={true} scroll={false}>
        <Stack padding={2} spacing={1}>
          <SearchField onChange={setSearchQuery} />
          <Stack direction={'row'}>
            <Button add={true} onClick={createDepartment}>
              Department
            </Button>
          </Stack>
        </Stack>
        <Divider />
        <Stack flex={'1 0 auto'}>
          <VirtualizedList
            divider={false}
            data={searchedData}
            button={false}
            withSearch={!!searchQuery}
            secondaryAction={({ actions, ...item }) => (
              <Actions actions={actions} data={item} />
            )}
          />
        </Stack>
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};

export default Departments;
